<template>
  <div
    class="block-flat"
    :class="{ 'block-flat--uniform': uniformPadding }"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    uniformPadding: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<style lang="scss" scoped>
.block-flat {
  display: flow-root;
  padding: 1em 2em;

  &--uniform {
    padding: 1em;
  }
}
</style>
